<template>
  <div class="root">
    <div class="header-box add-bg">
      <div class="c-header clearfix">
        <div class="header-logo">
          <a href="/">
            <img src="./images/header-logo-orange-xd.png">
          </a>
        </div>
        <!-- <div class="credit">
        <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
        <div class="qrcode-box">
          <i class="close-btn" @click="closeQrcode"></i>
          <div class="qrcode-content">
            <p>风险信用不可小觑</p>
            <p>您有一份征信报告待查看</p>
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
            <div class="foot">扫码即刻查征信</div>
          </div>
        </div>
      </div> -->
        <ul class="nav">
          <li v-for="(item,index) in navList" :key="index">
            <a @click="goUrl(item.url)" :class="{ active:index==currentPage}">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="banner">
      <div class="bg">
        <span class="andriod" @click="goAndriod"></span>
        <span class="ios" @click="goIOS"></span>
      </div>
    </div> -->
    <div class="section-1">
      <h2><i class="left"></i>四大业务方向,共同发力<i class="right"></i></h2>
      <ul>
        <li>
          <img style="margin-top:65px;" src="./images/icon-fenqi.png" alt="">
        </li>
        <li>
          <h2>分期业务</h2>
          <p>支持消费分期、现金分期</p>
          <p>为猪八戒网用户提供先消费后付款服务</p>
          <p>更为有资金需要的用户提供短期小额的</p>
          <p>现金周转服务</p>
          <p>纯线上 放款快 分期灵活</p>
        </li>
        <li>
          <h2>小微业务</h2>
          <p>为小微企业及企业主提供经营贷款</p>
          <p>快速解决中小微企融资问题</p>
          <p>快捷方便</p>
        </li>
        <li>
          <img style="margin-top:45px;" src="./images/icon-xiaowei.png" alt="">
        </li>
        <li>
          <img style="margin-top:62px;" src="./images/icon-chain.png" alt="">
        </li>
        <li>
          <h2>供应链金融</h2>
          <p>连通猪八戒网服务商和雇主两端用户,</p>
          <p>提供应收账款融资服务</p>
          <p>保证上下游资金链稳定,助力交易顺利达成</p>
        </li>
        <li>
          <h2 style="padding-top:40px;">抵押贷款</h2>
          <p>为有需求的用户提供房抵贷</p>
          <p>放款快,费率低,通过率快</p>
        </li>
        <li>
          <img style="margin-top:58px;" src="./images/icon-loan.png" alt="">
        </li>
      </ul>
    </div>
    <div class="section-2">
      <h2><i class="left"></i>更多小微场景 建设普惠金融<i class="right"></i></h2>
      <ul>
        <li class="right-margin bottom-margin">
          <img src="./images/scene-1.png" alt="">
          <p>循环额度</p>
        </li>
        <li class="right-margin bottom-margin">
          <img src="./images/scene-2.png" alt="">
          <p>起点分期</p>
        </li>
        <li class="bottom-margin">
          <img src="./images/scene-3.png" alt="">
          <p>提前收款</p>
        </li>
        <li class="right-margin">
          <img src="./images/scene-4.png" alt="">
          <p>八戒借条</p>
        </li>
        <li class="right-margin">
          <img src="./images/scene-5.png" alt="">
          <p>教育分期</p>
        </li>
        <li>
          <img src="./images/scene-6.png" alt="">
          <p>宠物分期</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "scene-service",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 3,
      iosUrl: "",
      andriodUrl: "",
    };
  },
  mounted() {
    this.$bus.$emit("ready");
    this.getAppUrl();
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    getAppUrl() {
      this.$ajax({
        url: "/venture/getUrl",
        method: "get",
        directAjax: true,
      }).then((rs) => {
        console.log(rs);
        if (rs.success && rs.data) {
          rs.data.forEach((item) => {
            if (item.dictId === "ANDROID_APK_URL") {
              this.andriodUrl = item.dictValue;
            }
            if (item.dictId === "IOS_URL") {
              this.iosUrl = item.dictValue;
            }
          });
        } else {
          this.iosUrl = "";
          this.andriodUrl = "";
        }
      });
    },
    goAndriod() {
      if (this.andriodUrl === "") {
        this.$message("下载地址获取失败，请稍后再试");
      } else {
        window.open(this.andriodUrl);
      }
    },
    goIOS() {
      if (this.iosUrl === "") {
        this.$message("下载地址获取失败，请稍后再试");
      } else {
        window.open(this.iosUrl);
      }
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>

<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.root {
  background-color: #f0f1f7;
}
.header-box {
  width: 100%;
  height: 104px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  &.add-bg {
    background: url("./images/white-header-bg.png") no-repeat top center;
  }
}
.c-header {
  background-color: #fff;
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  background-color: transparent;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./images/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./images/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./images/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./images/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #666;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #333333;
          border-bottom: 2px solid #ff6900;
        }
        &.active {
          color: #333333;
          border-bottom: 2px solid #ff6900;
        }
      }
    }
  }
}
.banner {
  width: 100%;
  height: 817px;
  padding-top: 80px;
  background-color: #fff;
  .bg {
    width: 100%;
    height: 806px;
    background: url("./images/sense-banner.png") no-repeat center;
    position: relative;
    span {
      position: absolute;
      width: 174px;
      height: 50px;
      cursor: pointer;
      right: 50%;
      margin-right: -400px;
      &.andriod {
        top: 493px;
      }
      &.ios {
        top: 566px;
      }
    }
  }
}
.section-1 {
  padding-top: 100px;
  width: 100%;
  height: auto;
  background-color: #f0f1f7;
  h2 {
    width: 878px;
    height: 200px;
    line-height: 200px;
    text-align: center;
    position: relative;
    margin: 0 auto;
    font-size: 42px;
    color: #333333;
    font-weight: bold;
    i {
      position: absolute;
      width: 156px;
      height: 7px;
      top: 96px;
      &.left {
        background: url("./images/icon-left-circle.png") no-repeat;
        left: 0px;
      }
      &.right {
        background: url("./images/icon-right-circle.png") no-repeat;
        right: 0px;
      }
    }
  }
  ul {
    padding-top: 70px;
    padding-bottom: 100px;
    height: 1400px;
    width: 900px;
    margin: 0 auto;
    li {
      width: 450px;
      float: left;
      height: 350px;
      box-sizing: border-box;
      img {
        margin-left: 70px;
      }
      h2 {
        font-size: 36px;
        width: 100%;
        color: #333333;
        line-height: 70px;
        height: 70px;
        font-weight: bold;
        text-align: left;
      }
      p {
        color: #666666;
        font-size: 22px;
        text-align: left;
        line-height: 40px;
        height: 40px;
      }
    }
  }
}
.section-2 {
  width: 100%;
  background-color: #ffffff;
  padding-bottom: 100px;
  h2 {
    width: 940px;
    height: 187px;
    line-height: 187px;
    text-align: center;
    position: relative;
    margin: 0 auto;
    font-size: 42px;
    color: #333333;
    font-weight: bold;
    i {
      position: absolute;
      width: 156px;
      height: 7px;
      top: 90px;
      &.left {
        background: url("./images/icon-left-circle.png") no-repeat;
        left: 0px;
      }
      &.right {
        background: url("./images/icon-right-circle.png") no-repeat;
        right: 0px;
      }
    }
  }
  ul {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0px;
    height: 548px;
    li {
      width: 378px;
      height: 254px;
      float: left;
      position: relative;
      overflow: hidden;
      &.right-margin {
        margin-right: 32px;
      }
      &.bottom-margin {
        margin-bottom: 40px;
      }
      img {
        width: 100%;
        top: 0;
        position: relative;
        left: 0;
        -webkit-transition: -webkit-transform 0.3s;
        -moz-transition: -moz-transform 0.3s;
        -o-transition: -o-transform 0.3s;
        transition: transform 0.3s;
        &:hover {
          -webkit-transform: scale(1.2);
          -moz-transform: scale(1.2);
          -ms-transform: scale(1.2);
          -o-transform: scale(1.2);
          transform: scale(1.2);
        }
      }
      &:hover {
        img {
          -webkit-transform: scale(1.2);
          -moz-transform: scale(1.2);
          -ms-transform: scale(1.2);
          -o-transform: scale(1.2);
          transform: scale(1.2);
        }
      }
      p {
        position: absolute;
        width: 100%;
        height: 70px;
        line-height: 70px;
        top: 100px;
        left: 0;
        background: url("./images/icon-double-color.png") no-repeat top center;
        color: #ffffff;
        font-size: 28px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// sceneService.vue?61b15f2c